export var SendgridMessageEventType;
(function (SendgridMessageEventType) {
    SendgridMessageEventType["Bounce"] = "bounce";
    SendgridMessageEventType["Click"] = "click";
    SendgridMessageEventType["Deferred"] = "deferred";
    SendgridMessageEventType["Dropped"] = "dropped";
    SendgridMessageEventType["Open"] = "open";
    SendgridMessageEventType["SpamReport"] = "spamreport";
    SendgridMessageEventType["Processed"] = "processed";
    SendgridMessageEventType["Delivered"] = "delivered";
})(SendgridMessageEventType || (SendgridMessageEventType = {}));
export const failedEmailEventTypes = [
    SendgridMessageEventType.Bounce,
    SendgridMessageEventType.Deferred,
    SendgridMessageEventType.Dropped,
    SendgridMessageEventType.SpamReport,
];
//# sourceMappingURL=sendgridMessageEvent.js.map